export default __webpack_public_path__ + "static/media/LAPTOP-1282x881px.30764f7f.png";